import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as ReactDomClient from 'react-dom/client';
import * as ReactIntl from 'react-intl';
import * as jsxRuntime from 'react/jsx-runtime';

window.Evelin = window.Evelin || {};
window.Evelin.fragments = window.Evelin.fragments || {};

window.Evelin.fragments['react-base-fragment'] = {
    react19: {
        React,
        // react 19 moved createRoot/hydrateRoot into react-dom/client; merge them in so
        // fragments keep the single flat ReactDom surface they were built against.
        ReactDom: { ...ReactDom, ...ReactDomClient },
        ReactIntl,
        jsx: jsxRuntime,
        version: React.version,
    },
};

window.dispatchEvent(new Event('evelin:ready'));
